import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var ReturnsIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 20 20" }),
    React.createElement("path", { d: "M8 6.5v-4l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" }))); };

export { ReturnsIcon as default };
